import { Navigate, useRoutes } from 'react-router-dom';
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';

import { useState } from 'react';
import Edit from './pages/edituser/Edit';
import VerifyEmail from './sections/verifyemail/verifyEmail';
import VerifyCompany from './sections/verifyemail/verifyCompany';
import Register from './sections/register/register';
import ProfileDetails from './pages/ProfileDetails/ProfileDetails';
import AddListing from './pages/Listing/AddListing';
import Dashboard from './pages/MainDashboard/Dashboard';
import Listings from './pages/Listing/Listings';
import Categories from './pages/Categories/Categories';
import NewCategory from './pages/Categories/NewCategory';
import Companies from './pages/Companies/Companies';
import ResetPassword from './sections/resetPassword/ResetPassword';
import ListingsView from './pages/Listing/ListingView';
import EditCompanyProfile from './pages/Companies/EditCompany';
import { useSelector } from 'react-redux';
import Events from './pages/Events/Events';
import AddEvent from './pages/Events/AddEvent';
import EditEvent from './pages/Events/EditEvent';
import Markeing from './pages/Marketing/Markeing';
import Notification from './pages/Notification/Notification';
import AddCompanyProfile from './pages/Companies/AddCompany';

export default function Router(props) {
  const [role, setRole] = useState(props && props.role || '');
  const user = useSelector((state) => state.user.user);

  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'profile-details', element: <ProfileDetails role={role} /> },
        { path: 'listings', element: <Listings role={role} /> },
        { path: 'marketing', element: <Markeing role={role} /> },
        { path: 'events', element: <Events role={role} /> },
        { path: 'add-event', element: <AddEvent role={role} /> },
        { path: 'edit-event/:id', element: <EditEvent role={role} /> },

        ...(user?.role !== 'user' ? [
          { path: 'categories', element: <Categories role={role} /> },
          { path: 'companies', element: <Companies role={role} /> },
          { path: 'add-company', element: <AddCompanyProfile role={role} /> },
          { path: 'edit-company/:id', element: <EditCompanyProfile role={role} /> },
          { path: 'new-category', element: <NewCategory role={role} /> },
          { path: 'notification', element: <Notification role={role} /> },
        ] : []),

        { path: 'new-listing', element: <AddListing role={role} /> },
        { path: 'edit-listing/:id', element: <AddListing edit={true} role={role} /> },
        { path: 'app', element: <Dashboard role={role} /> },
      ],
    },
    { path: '/listingsView', element: <ListingsView role={role} /> },
    { path: '/', element: <SimpleLayout />, children: [{ path: '/', element: <LoginPage /> }] }, // Login Page
    { path: '*', element: <Page404 /> }, // 404 page for unmatched routes
    { path: 'edit', element: <Edit /> },
    { path: 'reset-password/:token', element: <ResetPassword /> },
    { path: 'verify/:token', element: <VerifyEmail /> },
    { path: 'verify-company/:token', element: <VerifyCompany /> },
    { path: 'register', element: <Register /> },



  ]);

  return routes;
}